import React from "react";
import ReactDOM from "react-dom/client";
import App from "App";
import "index.css";
import "@radix-ui/themes/styles.css";
import { Theme, ThemePanel } from "@radix-ui/themes";
import { IsAuthenticatedProvider } from "context/IsAuthenticatedContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Theme
      accentColor="gray"
      grayColor="slate"
      radius="full"
      scaling="100%"
      appearance="dark"
    >
      <IsAuthenticatedProvider>
        <App />
      </IsAuthenticatedProvider>
      {/* <ThemePanel /> */}
    </Theme>
  </React.StrictMode>
);
